<!--=============================
=            ECHARTS            =
==============================-->

<template>
  <!-- ECHARTS -->
  <!-- APEXCHARTS -->
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Echarts</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Echarts Bar
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-3">
              <div id="echart1" style="padding:15px; height:400px;"></div>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Echarts Bar
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-3">
              <div id="echart2" style="padding:15px; height:400px;"></div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Echarts Bar
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-3">
              <div id="echart3" style="padding:15px; height:400px;"></div>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Echarts Bar
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-3">
              <div id="echart4" style="padding:15px; height:400px;"></div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Echarts Line1
            <div class="textt"></div>
          </div>
          <div slot="card-body">
            <div class="pa-3">
              <div id="echart5" style="padding:15px; height:400px;"></div>
            </div>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Echarts Line2</div>
          <div slot="card-body">
            <div class="pa-3">
              <div id="echart6" style="padding:15px; height:400px;"></div>
            </div>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  mounted() {
    var chartdata = [
      {
        name: "sales",
        type: "bar",
        data: [10, 15, 9, 18, 10, 15]
      },
      {
        name: "profit",
        type: "line",
        smooth: true,
        data: [8, 5, 25, 10, 10]
      },
      {
        name: "growth",
        type: "bar",
        data: [10, 14, 10, 15, 9, 25]
      }
    ];

    var chart = document.getElementById("echart1");
    var barChart = echarts.init(chart);

    var option = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "25"
      },
      xAxis: {
        data: ["2014", "2015", "2016", "2017", "2018"],
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      tooltip: {
        show: true,
        showContent: true,
        alwaysShowContent: true,
        triggerOn: "mousemove",
        trigger: "axis",
        axisPointer: {
          label: {
            show: false
          }
        }
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata,
      color: ["#9f78ff", "#fa626b", "#32cafe"]
    };

    barChart.setOption(option);

    /*-----echart1-----*/
    var chartdata2 = [
      {
        name: "sales",
        type: "line",
        smooth: true,
        data: [12, 25, 12, 35, 12, 38],
        color: ["#9f78ff"]
      },
      {
        name: "Profit",
        type: "line",
        smooth: true,
        size: 10,
        data: [8, 12, 28, 10, 10, 12],
        color: ["#32cafe"]
      }
    ];

    var chart2 = document.getElementById("echart2");
    var barChart2 = echarts.init(chart2);

    var option2 = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "25"
      },
      xAxis: {
        data: ["2014", "2015", "2016", "2017", "2018"],
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata2
    };
    barChart2.setOption(option2);

    /*-----echart3-----*/

    var option3 = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "32"
      },
      xAxis: {
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        type: "category",
        data: ["2014", "2015", "2016", "2017", "2018"],
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#c0dfd8"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata,
      color: ["#9f78ff", "#fa626b", "#32cafe"]
    };

    var chart3 = document.getElementById("echart3");
    var barChart3 = echarts.init(chart3);
    barChart3.setOption(option3);

    /*-----echart4-----*/

    var option4 = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "32"
      },
      xAxis: {
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        type: "category",
        data: ["2014", "2015", "2016", "2017", "2018"],
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata2,
      color: ["#9f78ff", "#32cafe", "#ecb403"]
    };

    var chart4 = document.getElementById("echart4");
    var barChart4 = echarts.init(chart4);
    barChart4.setOption(option4);

    /*-----echart5-----*/

    var chartdata3 = [
      {
        name: "sales",
        type: "bar",
        stack: "Stack",
        data: [14, 18, 20, 14, 29, 21, 25, 14, 24]
      },
      {
        name: "Profit",
        type: "bar",
        stack: "Stack",
        data: [12, 14, 15, 50, 24, 24, 10, 20, 30]
      }
    ];

    var option5 = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "25"
      },
      xAxis: {
        data: [
          "2010",
          "2011",
          "2012",
          "2013",
          "2014",
          "2015",
          "2016",
          "2017",
          "2018"
        ],
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata3,
      color: ["#9f78ff", "#32cafe"]
    };

    var chart5 = document.getElementById("echart5");
    var barChart5 = echarts.init(chart5);
    barChart5.setOption(option5);

    /*-----echart6-----*/

    var option6 = {
      grid: {
        top: "6",
        right: "10",
        bottom: "17",
        left: "32"
      },
      xAxis: {
        type: "value",
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        type: "category",
        data: [
          "2010",
          "2011",
          "2012",
          "2013",
          "2014",
          "2015",
          "2016",
          "2017",
          "2018"
        ],
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata3,
      color: ["#9f78ff", "#32cafe"]
    };

    var chart6 = document.getElementById("echart6");
    var barChart6 = echarts.init(chart6);
    barChart6.setOption(option6);

    /*-----echart7-----*/

    var chartdata4 = [
      {
        name: "data",
        type: "line",
        data: [20, 20, 36, 18, 15, 20, 25, 20]
      }
    ];

    var option7 = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "25"
      },
      xAxis: {
        data: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata4,
      color: ["#9f78ff"]
    };

    var chart7 = document.getElementById("echart7");
    var lineChart = echarts.init(chart7);
    lineChart.setOption(option7);

    /*-----echart8-----*/
    var chartdata5 = [
      {
        name: "data",
        type: "line",
        smooth: true,
        data: [20, 20, 36, 18, 15, 20, 25, 20]
      }
    ];

    var option8 = {
      grid: {
        top: "6",
        right: "0",
        bottom: "17",
        left: "25"
      },
      xAxis: {
        data: ["2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018"],
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      yAxis: {
        splitLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLine: {
          lineStyle: {
            color: "#eaeaea"
          }
        },
        axisLabel: {
          fontSize: 10,
          color: "#000"
        }
      },
      series: chartdata5,
      color: ["#32cafe"]
    };

    var chart8 = document.getElementById("echart8");
    var lineChart2 = echarts.init(chart8);
    lineChart2.setOption(option8);
  }
};
</script>
<style>
.textt {
  overflow: hidden;
  font-size: 12px;
  overflow: hidden !important;
  max-width: auto;
  max-height: 28px;
  text-overflow: ellipsis;
  line-height: 14px !important;
  white-space: inherit;
  vertical-align: top;

  word-wrap: break-word;
  align-items: center;
}

.card_tittle {
  line-height: 1 !important;
}
</style>

<!--====  End of ECHARTS  ====-->
